import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import {savaSuggest} from "@/servers/storeManageApi";
import './index.scss'
import {Button, Modal, Input, message} from "antd";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getSuggest} from "../../../../servers/menuAPI";
import { getStorage} from "@/utils";
import {refreshMenu} from "../../../../redux/common/action";
import CInput from '@/components/CForm/CInput'
import CRadio from '@/components/CForm/CRadio'
import store from "../../../../redux";
const { TextArea } = Input;
@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangetext = this.onChangetext.bind(this);
  }


  state = {
    data: [],
    tips:'',
    searchData: {
      value: '',//搜索框筛选
      placeholder: '请输入评分'
    },
    isModalVisible:false,
    previewImage:'',
    options:[
      {
        value:1,name:'是'
      },
      {
        value:0,name:'否'
      },
    ],
    select:'',
    suggest:'',
    museumid:''
  }

  showModal = () => {
    this.setState({
      isModalVisible:true
    })
  };

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  };

  onSubmit(){
    if (this.state.suggest.length > 200) {
      message.error('本年度综合建议字数在200字以内');
      return false
    }
    const result = JSON.parse(localStorage.getItem('userList'))
    const params = {
      action: this.state.select,
      museumid:result.museumid?result.museumid:store.getState().libraryid,
      notes: encodeURIComponent(this.state.suggest)
    }
    savaSuggest(params).then(res=>{
      if(res.statecode === 0) {
        message.success('保存成功');
      } else {
        message.error(res.statemessage);
      }
    })
  }

  onChange(value) {
    this.setState({
      select:value
    })
  }

  onChangetext(e){
    if (e.target.value.length > 200) {
      message.error('综合建议字数在200字以内');
      return false
    }
    this.setState({
      suggest:e.target.value
    })
  }

  onSelect(){
    const result = JSON.parse(localStorage.getItem('userList'))
    const params = {
      annual:result.annual,
      museumid:this.state.museumid,
    }
    getSuggest(params).then(res=>{
      if (res.statecode === 0 ){
        this.setState({
          suggest:res.records[0].datalist.length>0?decodeURIComponent(res.records[0].datalist[0].notes):'',
          select: Number(res.records[0].datalist.length>0?res.records[0].datalist[0].action === '是' ? 1 : 0:''),
        })
      } else {
        message.error(res.statemessage)
      }
    })
  }

  componentDidMount(){
    const result = JSON.parse(localStorage.getItem('userList'))
    if (result.clerklevel === 8 || result.clerklevel === 9){
      this.setState({
        museumid:result.museumid,
      },()=>{
        this.onSelect()
      })
    } else {
      this.setState({
        museumid:store.getState().libraryid
      },()=>{
        this.onSelect()
      })
    }
    store.subscribe(() => {
      const state = store.getState()
      if (state.libraryname){
        const museumid = store.getState().libraryid
        this.setState({
          museumid:museumid,
        },()=>{
          this.onSelect();
        })
      }
    })
  }

  render(){
    return (
        <div className='user-manage-list'>
            <h3 style={{fontSize:'18px'}}>综合建议（200字以内）</h3>
            <TextArea rows={20}
                      value={decodeURIComponent(this.state.suggest)}
                      onChange={(e) => this.onChangetext(e)}
            />
            <div style={{marginTop:'20px'}}>
              <span style={{marginRight:'10px'}}>是否建议现场考察</span>
              <CRadio
                  value={this.state.select}
                  options={this.state.options}
                  onChange={this.onChange}
              />
            </div>
            <Button type="primary" className='yl' onClick={this.onSubmit}>保存</Button>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
